module.exports = __webpack_public_path__ + "img/logo.add3fb2b.svg";